module.exports = __webpack_public_path__ + "img/login-v2-dark.02c9f92f.svg";